import React from 'react'
import styled from 'styled-components'

import { ActionButton } from '../BottomHeader/ActionButton'
import { useHistory } from 'react-router'

export const GoBackButton: React.FC = () => {
  const history = useHistory()
  return <Button label="Back" onClick={history.goBack} />
}

const Button = styled(ActionButton)`
  && {
    margin: 17px auto 17px 24px;
  }
`
